import i18next from 'i18next';

import { OrganizationalUnitDistribution } from 'components/types';

import { formatByLocale } from 'utils/date';

export const getDistributionTitle = ({
  startDate,
  endDate
}: OrganizationalUnitDistribution) =>
  `${formatByLocale(new Date(startDate), 'PP')} - ${
    endDate ? formatByLocale(new Date(endDate), 'PP') : i18next.t('indefinite')
  }`;
